import { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import axios from "axios";
import * as Yup from 'yup';
import { API_URL } from '../../constants';
import TextInput from '../../components/Forms/TextInput';
import {Box, Typography, InputAdornment, Button, Divider} from '@mui/material';
import { useTheme } from '@mui/material';
import MailIcon from "@mui/icons-material/Mail";

import EmailConfCard from './EmailConfCard';
import PagePublic2Col from '../../components/Page/PagePublic2Col';
import { IMAGE_RUN } from '../../constants';
import { useTranslation } from "../../language";
import LanguageSelector from '../../language';
import ButtonsTextGoTo from '../../components/Button/ButtonTextGo';


const buildResendSchema = (t) => Yup.object({
  email: Yup.string()
    .email(t("val_email_valid"))
    .max(254, t("val_email_max"))
    .required(t("val_email_req")),
});


export default function EmailConfPage() {

  const { t, changeLanguage } = useTranslation();
  const theme = useTheme();
  const [statusMessage, setStatusMessage] = useState(null);

  // German is the default language for this page
  useEffect(() => {
    changeLanguage('de');
  }, []);

async function handleResend(values, { setSubmitting, resetForm }) {
    setStatusMessage(null);
    try {
      const response = await axios.post(`${API_URL}/auth/resend-verification/`, values);

      setStatusMessage(response.data.message);
      resetForm();
    } catch (error) {
      setStatusMessage(
        error.response?.data?.error ||
        t("val_server_error")
      );
    } finally {
      setSubmitting(false);
    }
  }

    return (
        
  <PagePublic2Col 

      leftsideimage={IMAGE_RUN}
      brandtext="Preventive Health Intelligence"
      headline=""
      formcomp={
     
           <EmailConfCard
                    topic = ''
                    content = {<>

                                 <Box sx={{mb:4}}> <LanguageSelector /> </Box>

                                <Typography variant="h2" align="center" color='common.black' sx={{ mb: 4 }}> {t("onb_email_title")} </Typography>

                                <Typography variant="subtitle1" align="center" sx={{mt: 1, fontWeight: 400 }}>
                                {t("onb_email2")} <br /><br />
                                {t("onb_email5")} <br />
                                {t("onb_email5b")} <br />
                                </Typography>

                              <Box sx={{ mt: 12 }} />
                              {t("onb_email4")} <br />

                              <Formik
                                  initialValues={{ email: '' }}
                                  validationSchema={buildResendSchema(t)}
                                  onSubmit={handleResend}
                                >
                                  {({ isSubmitting }) => (
                                    
                                    <Form>  
                                    
                                      <TextInput
                                        label="Email"
                                        name="email"
                                        type="email"
                                        placeholder="Email"
                                        InputProps={{
                                          startAdornment: (
                                            <InputAdornment position="start">
                                              <MailIcon />
                                            </InputAdornment>
                                          ),
                                        }}
                                      />

                                      <Button
                                        variant="text"
                                        type="submit"
                                        disabled={isSubmitting}
                                        sx={{
                                          minWidth: { xs: 80, sm: 90, md: 100 },
                                          p: '10px',
                                          color: theme.palette.mode === 'light' ? 'common.black' : 'grey.C100',
                                          fontWeight: 600,
                                          transition: 'transform 0.2s ease',
                                          '&:hover': {
                                            p: '10px 12px',
                                            color: 'common.white',
                                            bgcolor: 'greydark.C900',
                                            borderRadius: 5,
                                            transform: 'scale(1.08)',
                                          },
                                        }}
                                      >
                                        {t("onb_email6")}
                                      </Button>
                                    </Form>
                                  )}
                                </Formik>

              {statusMessage && (
                <Typography
                  variant="body2"
                  align="center"
                  sx={{ mt: 3 }}
                >
                  {statusMessage}
                </Typography>
              )}

                              <Divider sx={{ mt: 4, mb: 3 }} />

                              <Typography variant="subtitle1" fontWeight={400} align="center">
                                {t("onb_email7")}
                              </Typography>
                              <Typography variant="subtitle1" align="center" color="text.secondary" sx={{ mt: 0.5, mb: 2 }}>
                                {t("onb_email8")}
                              </Typography>
                              <ButtonsTextGoTo to="/Login" name={t("onb_email9")} />

        </>}
      /> 
      }
    />
  )
}
/*
 <ButtonsText name={t("onb_email6")} onClick={resendVerification} color="common.black"/>
   <Linkgroup destination='/Login' button_name='Sign In' /> 
*/

